// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IncidentHistoryResponseMeta } from './IncidentHistoryResponseMeta';
import {
    IncidentHistoryResponseMetaFromJSON,
    IncidentHistoryResponseMetaFromJSONTyped,
    IncidentHistoryResponseMetaToJSON,
    IncidentHistoryResponseMetaToJSONTyped,
} from './IncidentHistoryResponseMeta';
import type { IncidentHistory } from './IncidentHistory';
import {
    IncidentHistoryFromJSON,
    IncidentHistoryFromJSONTyped,
    IncidentHistoryToJSON,
    IncidentHistoryToJSONTyped,
} from './IncidentHistory';

/**
 * 
 * @export
 * @interface IncidentHistoryResponse
 */
export interface IncidentHistoryResponse {
    /**
     * 
     */
    data?: Array<IncidentHistory>;
    /**
     * 
     */
    meta?: IncidentHistoryResponseMeta;
}

/**
 * Check if a given object implements the IncidentHistoryResponse interface.
 */
export function instanceOfIncidentHistoryResponse(value: object): value is IncidentHistoryResponse {
    return true;
}

export function IncidentHistoryResponseFromJSON(json: any): IncidentHistoryResponse {
    return IncidentHistoryResponseFromJSONTyped(json, false);
}

export function IncidentHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(IncidentHistoryFromJSON)),
        'meta': json['meta'] == null ? undefined : IncidentHistoryResponseMetaFromJSON(json['meta']),
    };
}

export function IncidentHistoryResponseToJSON(json: any): IncidentHistoryResponse {
    return IncidentHistoryResponseToJSONTyped(json, false);
}

export function IncidentHistoryResponseToJSONTyped(value?: IncidentHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(IncidentHistoryToJSON)),
        'meta': IncidentHistoryResponseMetaToJSON(value['meta']),
    };
}

